<template>
  <div class="relative">
    <div class="z-10 h-full absolute background top-0 w-full pt-[140px]">
      <div class="h-full w-full px-4">
        <div class="relative h-full">
          <!-- login component  -->
          <div>
            <div>
              <div>
                <div
                  style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
                  :class="textStyle"
                  class="w-full text-white text-center h-[64px] pt-[15px] text-[32px] "
                >
                  BUYERS PORTAL
                </div>
                <div
                  style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
                  :class="textStyle"
                  class="
                  mb-4
                  text-[#ED7D31]
                  left-0
                  w-full
                  text-center
                  justify-center
                  items-center
                  pb-[0px]
                  text-[11px]
                  "
                >
                  BY MOLDEX REALTY, INC.
                </div>
              </div>
              <!-- ============== -->
            </div>

            <div v-if="BISSelectionComponent" class="w-full px-4">
              <div class="text-center opacity1 ">
                <BISSelection></BISSelection>
              </div>
            </div>
            <div class="w-full px-4">
              <div>
                <div class="text-center bg-white" v-if="!hide">
                  <!-- if login  -->
                  <div class="pt-4">
                    <div>
                      <!-- here  -->
                      <div class="px-4">
                        <div class="my-2">
                          <input
                            class="bg-white border-solid border-2 rounded-md border-black w-full px-4 py-2 outline-none"
                            type="email"
                            v-model="email"
                            placeholder="Email"
                          />
                        </div>
                        <div class="my-2 flex justify-start w-full">
                          <div
                            class="border-solid border-2 rounded-md border-black flex justify-between w-full items-center"
                          >
                            <input
                              class="bg-white w-full rounded-md px-4 py-2 outline-none"
                              :type="pwVisible ? 'password' : 'text'"
                              v-model="password"
                              placeholder="Password"
                            />
                            <v-btn @click="openPwVisibility" text>
                              <v-icon v-if="pwVisible">mdi-eye-off</v-icon>
                              <v-icon v-else>mdi-eye</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-center my-4">
                        <div class="text-center w-full h-[75px] mt-4">
                          <div>
                            <v-btn
                              dark
                              :loading="loading"
                              color="#ED7D31"
                              @click="submit"
                              class="w-[150px]"
                            >
                              <div>Log in</div>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-full">
                      <v-progress-linear
                        v-if="progressbar"
                        color="white"
                        :indeterminate="indeterminate"
                      ></v-progress-linear>
                    </div>
                  </div>
                </div>
                <div class="items-center flex justify-center">
                  <span
                    ><img :src="img" alt="" class="mt-[50px] w-[120px]"
                  /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="absolute inset-0 bg-black opacity-70"></div>
      <img :src="background_image" class="h-screen splashImage w-full" />
    </div>
    <!-- <img :src="background_image" class="h-screen splashImage w-full" /> -->

    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable */
import PasswordRequest from "./components/PasswordRequest.vue";
import EventBus from "@/EventBus";
import ContractNumber from "./SignUpScreen/components/ContractNumber.vue";
import Otp from "./components/Otp.vue";
import PassWord from "./SignUpScreen/components/PassWord.vue";
import BISSelection from "@/screens/authScreen/SignUpScreen/components/BISSelection.vue";
import axios from "axios";
import SecureStorage from '../../utils/secureStorage.js';

export default {
  data() {
    return {
      loading: false,
      textStyle: "font-bold leading-loose tracking-wide font-noto-sans",
      progressbar: false,
      indeterminate: false,
      pwVisible: true,
      buyerName: null,
      customerCode: null,
      emailFound: "",
      BISSelectionComponent: false,
      hide: false,
      dialogNoEmail: false,
      signupPw: false,
      logInShow: true,
      otp: false,
      contractNumber: null,
      contractNumberPrefix: null,
      isSignup: false,
      rfp_dialog: false,
      snackbar: false,
      snackbarText: "",
      email: "",
      password: "",
      dialog: false,
      // title_heading: "WELCOME TO ",
      subtitle1: "Already have an account? Login here.",
      subtitle2: "Don't have an account yet?",
      // signup: "Sign up here.",
      subtitlePW:
        "Minimum of 8 characters, at least one capital letter, one small letter, and one number. ",
      // subtitleOtp:"Enter the One-Time-Pin sent to your registered e-mail with Moldex",
      messageNoEmail: "",
      img: require("@/assets/images/moldex_logo.png"),
      background_image: require("@/assets/images/bg_login.jpg"),
    };
  },
  mounted() {
    EventBus.$on("closeSignup", () => {
      this.closeSignup();
    });
    EventBus.$on("Close_RFP_DIALOG", () => {
      this.rfp_dialog = false;
    });
    EventBus.$on("snackbar_rfp", () => {
      this.snackbar = true;
      this.snackbarText =
        "Please check your email about your password request.";
    });
  },

  beforeDestroy() {
    EventBus.$off("snackbar_rfp");
    EventBus.$off("closeSignup");
    EventBus.$off("Close_RFP_DIALOG");
  },
  methods: {
    // async checkRole(user_id) {
    //   const { data: roleData, error: roleError } = await supabase
    //     .from("user_roles")
    //     .select("role")
    //     .eq("user_id", user_id);

    //   if (roleError) {
    //     console.error("Error fetching role:", roleError);
    //   } else if (
    //     roleData &&
    //     roleData.length > 0 &&
    //     roleData[0].role === "admin"
    //   ) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    openPwVisibility() {
      this.pwVisible = !this.pwVisible;
    },
    openBISSelection() {
      this.otp = false;
      this.hide = true;
      this.BISSelectionComponent = true;
    },
    chooseBIS() {
      this.dialogNoEmail = false;
      this.hide = true;
      this.BISSelectionComponent = true;
    },
    close_dialog_rfp() {
      this.rfp_dialog = false;
    },
    rfp() {
      this.rfp_dialog = true;
    },
    progressBar(e) {
      this.progressbar = e;
      this.indeterminate = e;
    },

    async submit() {
      this.loading = true;
      this.progressBar(true);
      if (!this.password || !this.email) {
        this.snackbar = true;
        this.snackbarText = "Please complete the text fields.";
        this.progressBar(false);
        this.loading = false;
      } else {
        this.loading = true;
        let payload = {
          email: this.email,
          password: this.password,
        };
        
        this.progressBar(true);
        try {
          const result = await axios.post("/login/login-admin", payload);
          if (result.data.status) {
            SecureStorage.setAuthData(result.data, true);
            
            this.progressBar(false);
            this.loading = false;

            this.$router.replace({
              name: "unassigned-tickets",
              params: {
                userId: SecureStorage.getItem('auth').userId,
              },
            });
          } else {
            this.loading = false;
            this.snackbar = true;
            this.snackbarText = result.data.message;
          }
        } catch (error) {
          this.loading = false;
          this.progressBar(false);
          this.snackbar = true;
          this.snackbarText = "Unable to connect to the server. Please try again.";
        }
      }
    },
  },
  components: {
    // Signup,
  },
};
</script>
<style>
/* .btnsignup,
.btnlogin {
  background: linear-gradient(0deg);
} */

.font1 {
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-weight: "bolder";
}

.fontBtn {
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-weight: "bolder";
  box-shadow: 0 1px 2px #fff, /*bottom external highlight*/ 0 -1px 1px #666,
    /*top external shadow*/ inset 0 -1px 1px rgba(0, 0, 0, 0.5),
    /*bottom internal shadow*/ inset 0 1px 1px rgba(255, 255, 255, 0.8); /*top internal highlight*/
  border-radius: 4px;
}
.fontBtn2 {
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-weight: "bolder";
  border-radius: 4px;
}
.font2 {
  color: #000093;
  font-family: "Arial";
  font-size: 27px;
  text-decoration-thickness: 2px;
}
.font3 {
  font-family: "Ballet", cursive;
}
.font5 {
  font-family: "Source Sans Pro";
  font-size: 10px;
}
.font6 {
  font-family: "Source Sans Pro";
  font-size: 11px;
}

.opacity1 {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
